<template>
    <div class="p-4">
        <!-- Lista extrase existente -->
        <div class="border rounded p-3 mb-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Extrase introduse</h5>
                <button
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="openForm"
                >
                    Adaugă extras
                </button>
            </div>

            <div v-if="loadingList" class="text-center py-3">
                <span class="spinner-border spinner-border-sm"></span>
            </div>
            <div v-else>
                <div v-if="existingExtrase.length">
                    <ul class="list-unstyled mb-0">
                        <li
                            v-for="item in existingExtrase"
                            :key="item.id"
                            class="mb-2"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{{ item.banca || '—' }}</strong>
                                    —
                                    {{ item.data_start }} - {{ item.data_end }}
                                </div>
                                <button
                                    type="button"
                                    class="btn btn-xs btn-success"
                                    @click="toggleExtras(item.id)"
                                    :title="expandedExtrasId === item.id ? 'Ascunde detaliile' : 'Vezi / adaugă linii extras'"
                                >
                                    <i class="fa-solid" :class="expandedExtrasId === item.id ? 'fa-minus' : 'fa-plus'"></i>
                                </button>
                            </div>

                            <div
                                v-if="expandedExtrasId === item.id"
                                class="mt-2 ms-3"
                            >
                                <!-- Tabel linii existente -->
                                <div v-if="tranzactiiByExtras[item.id] && tranzactiiByExtras[item.id].length">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered mb-2 align-middle">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="width: 140px;">Data</th>
                                                    <th style="width: 120px;" class="text-end">Debit (Suma)</th>
                                                    <th style="width: 120px;" class="text-end">Credit (Suma)</th>
                                                    <th style="width: 250px;">Cont Corespondent</th>
                                                    <th>Descriere</th>
                                                    <th style="width: 80px;" class="text-center">Acțiuni</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(t, idx) in tranzactiiByExtras[item.id]" :key="t.id">
                                                    <template v-if="editingLineId === t.id">
                                                        <td>
                                                            <div class="input-group input-group-sm">
                                                                <input type="date" class="form-control form-control-sm px-1" v-model="editLineData.data_tranzactie" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="number" step="0.01" class="form-control form-control-sm text-end" v-model.number="editLineData.suma_debit" />
                                                        </td>
                                                        <td>
                                                            <input type="number" step="0.01" class="form-control form-control-sm text-end" v-model.number="editLineData.suma_credit" />
                                                        </td>
                                                        <td style="min-width: 250px;">
                                                            <multiselect
                                                                v-model="editLineData.cont_corespondent_obj"
                                                                :options="listaConturi"
                                                                track-by="id"
                                                                label="cod_complet"
                                                                :custom-label="contLabel"
                                                                placeholder="Selectează cont"
                                                                select-label="Alege"
                                                                selected-label="Selectat"
                                                                deselect-label="Șterge"
                                                                :searchable="true"
                                                                :loading="loadingConturi"
                                                                @select="(opt) => editLineData.cont_corespondent = opt.cod_complet"
                                                            >
                                                                <template #option="props">
                                                                    <div class="d-flex justify-content-between">
                                                                        <span class="fw-bold">{{ props.option.cod_complet }}</span>
                                                                        <span class="text-muted small ms-2 text-truncate" style="max-width: 200px;">
                                                                            {{ props.option.descriere }}
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                            </multiselect>
                                                        </td>
                                                        <td>
                                                            <input type="text" class="form-control form-control-sm" v-model="editLineData.explicatie" />
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="d-flex justify-content-center gap-1">
                                                                <button class="btn btn-xs btn-success" @click="saveEditedLine(item.id, t.id)" title="Salvează">
                                                                    <i class="fa-solid fa-check"></i>
                                                                </button>
                                                                <button class="btn btn-xs btn-secondary" @click="cancelEditLine()" title="Anulează">
                                                                    <i class="fa-solid fa-xmark"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </template>
                                                    <template v-else>
                                                        <td>{{ t.data_tranzactie }}</td>
                                                        <td class="text-end">{{ t.suma_debit > 0 ? t.suma_debit : '' }}</td>
                                                        <td class="text-end">{{ t.suma_credit > 0 ? t.suma_credit : '' }}</td>
                                                        <td>
                                                            {{ (t.suma_debit > 0) ? t.cont_credit : ((t.suma_credit > 0) ? t.cont_debit : (t.cont_debit || t.cont_credit)) }}
                                                        </td>
                                                        <td>{{ t.explicatie }}</td>
                                                        <td class="text-center">
                                                            <button class="btn btn-xs btn-light-primary" @click="startEditLine(t, item.id)" title="Editează">
                                                                <i class="fa-solid fa-pen"></i>
                                                            </button>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else class="text-muted small mb-2">
                                    Nu există încă linii pentru acest extras.
                                </div>

                                <!-- Formular adăugare linie nouă -->
                                <div class="card card-body p-2">
                                    <div class="row g-2">

                                        <!-- Repeater linii contabile -->
                                        <div class="col-12">
                                            <div class="d-flex align-items-center justify-content-between mb-1">
                                                <label class="form-label form-label-sm fw-bold mb-0">Linii contabile</label>
                                                <button
                                                    type="button"
                                                    class="btn btn-light-primary btn-sm"
                                                    @click="liniiRJ.push({ data_tranzactie: dateAzi(), suma_debit: 0, suma_credit: 0, cont_corespondent: '', cont_corespondent_obj: null, explicatie: '' })"
                                                >
                                                    <i class="fa-solid fa-plus"></i> Adaugă linie
                                                </button>
                                            </div>

                                            <table class="table table-sm table-bordered align-middle mb-2">
                                                <thead>
                                                    <tr>
                                                        <th style="width:140px">Data</th>
                                                        <th style="width:120px" class="text-end">Debit (Suma)</th>
                                                        <th style="width:120px" class="text-end">Credit (Suma)</th>
                                                        <th>Cont Corespondent</th>
                                                        <th>Explicație</th>
                                                        <th style="width:48px"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${item.id}_${idx}`">
                                                        <td>
                                                            <div class="input-group input-group-sm">
                                                                <input
                                                                    type="date"
                                                                    class="form-control form-control-sm px-1"
                                                                    v-model="linie.data_tranzactie"
                                                                    :ref="'data_linie_' + idx"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    class="date-picker-btn btn btn-outline-secondary btn-sm px-1"
                                                                    @click="openNativePicker('data_linie_' + idx)"
                                                                    title="Alege data"
                                                                >
                                                                    📅
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                class="form-control form-control-sm text-end"
                                                                v-model.number="linie.suma_debit"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                class="form-control form-control-sm text-end"
                                                                v-model.number="linie.suma_credit"
                                                            />
                                                        </td>
                                                        <td style="min-width: 250px;">
                                                            <multiselect
                                                                v-model="linie.cont_corespondent_obj"
                                                                :options="listaConturi"
                                                                track-by="id"
                                                                label="cod_complet"
                                                                :custom-label="contLabel"
                                                                placeholder="Selectează cont"
                                                                select-label="Alege"
                                                                selected-label="Selectat"
                                                                deselect-label="Șterge"
                                                                :searchable="true"
                                                                :loading="loadingConturi"
                                                                @select="(opt) => linie.cont_corespondent = opt.cod_complet"
                                                            >
                                                                <template #option="props">
                                                                    <div class="d-flex justify-content-between">
                                                                        <span class="fw-bold">{{ props.option.cod_complet }}</span>
                                                                        <span class="text-muted small ms-2 text-truncate" style="max-width: 200px;">
                                                                            {{ props.option.descriere }}
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                            </multiselect>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                class="form-control form-control-sm"
                                                                v-model="linie.explicatie"
                                                                placeholder="Explicație"
                                                            />
                                                        </td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-light-danger"
                                                                @click="liniiRJ.splice(idx, 1)"
                                                            >
                                                                <i class="fa-solid fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="!liniiRJ.length">
                                                        <td colspan="5" class="text-center text-muted small py-2">
                                                            Apasă „Adaugă linie” pentru a introduce linii contabile.
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <small class="text-muted">
                                                Sfat: asigură-te că totalul debitelor = totalul creditelor.
                                            </small>
                                        </div>

                                        <div class="col-md-12 text-end mt-2">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-primary"
                                                :disabled="savingLine"
                                                @click="addLinie(item.id)"
                                            >
                                                <span
                                                    v-if="savingLine"
                                                    class="spinner-border spinner-border-sm me-1"
                                                ></span>
                                                Adaugă
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-else class="text-muted">
                    Nu există extrase pentru acest fișier.
                </div>
            </div>

        </div>

        <!-- Formular de introducere extras (opțional, doar când se apasă butonul) -->
        <div
            v-if="showForm"
            class="border rounded p-3 mb-3 bg-light"
        >
            <div
                v-if="showForm"
                class="d-flex justify-content-between align-items-center mb-3"
            >
                <h5 class="mb-0">Extras bancar nou</h5>

                <button
                    type="button"
                    class="btn btn-sm btn-light border"
                    @click="showForm = false"
                    title="Anulează"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <div class="row g-2">
                <div class="col-md-6">
                    <label class="form-label">Cont Contabil</label>
                    <multiselect
                        v-model="selectedCont"
                        :options="listaConturi"
                        track-by="id"
                        label="cod_complet"
                        :custom-label="contLabel"
                        placeholder="Selectează cont"
                        select-label="Alege"
                        selected-label="Selectat"
                        deselect-label="Șterge"
                        :searchable="true"
                        :loading="loadingConturi"
                        @select="onContSelected"
                    >
                        <template #option="props">
                            <div class="d-flex justify-content-between">
                                <span class="fw-bold">{{ props.option.cod_complet }}</span>
                                <span class="text-muted small ms-2 text-truncate" style="max-width: 200px;">
                                    {{ props.option.descriere }}
                                </span>
                            </div>
                        </template>
                    </multiselect>
                </div>

                <div class="col-md-6">
                    <label class="form-label">IBAN</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="extras.iban"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Monedă</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="extras.moneda"
                        placeholder="RON"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Lună</label>
                    <div class="input-group input-group-sm">
                        <input
                            type="month"
                            class="form-control form-control-sm"
                            v-model="extras.luna"
                            ref="luna"
                        />
                        <button
                            type="button"
                            class="date-picker-btn btn btn-outline-secondary btn-sm"
                            @click="openNativePicker('luna')"
                            aria-label="Deschide selector lună"
                        >
                            📅
                        </button>
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Sold inițial</label>
                    <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model="extras.sold_initial"
                        readonly
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Sold final</label>
                    <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model="extras.sold_final"
                        readonly
                    />
                </div>
            </div>
        </div>

        <!-- Mesaje -->
        <div v-if="error" class="alert alert-danger py-2">
            {{ error }}
        </div>
        <div v-if="success" class="alert alert-success py-2">
            {{ success }}
        </div>

        <!-- Buton salvare -->
        <div
            v-if="showForm"
            class="d-flex justify-content-end mt-3"
        >
            <button
                type="button"
                class="btn btn-success"
                :disabled="saving || !canSave"
                @click="saveExtrase"
            >
                <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                Salvează extrasele
            </button>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'ExtraseProcesare',

    components: { Multiselect },

    props: {
        firmaId: { type: Number, required: true },
        fisierId: { type: Number, required: false },
    },

    data() {
        return {
            extras: new Form({
                banca: '',
                iban: '',
                moneda: 'RON',
                luna: '',
                data_start: '',
                data_end: '',
                sold_initial: '',
                sold_final: '',
            }),
            listaConturi: [],
            selectedCont: null,
            loadingConturi: false,
            loadingSold: false,
            existingExtrase: [],
            loadingList: false,
            showForm: false,
            saving: false,
            savingLine: false,
            expandedExtrasId: null,
            tranzactiiByExtras: {},
            newLine: new Form({
                data_tranzactie: '',
                tip_tranzactie: '',
            }),
            liniiRJ: [],
            editingLineId: null,
            editLineData: null,
            // v-form instances for POST requests
            formExtras: new Form({
                id_firma: null,
                id_fisier: null,
                extrase: [],
            }),
            lineForm: new Form({
                extras_id: null,
                data_tranzactie: '',
                descriere: '',
                suma_debit: '',
                suma_credit: '',
            }),
            error: null,
            success: null,
        };
    },

    mounted() {
        this.loadExistingExtrase()
        this.loadConturi()
    },

    watch: {
        'extras.luna'(newVal) {
            if (newVal && this.selectedCont) {
                this.fetchSoldInitial();
            }
        }
    },

    computed: {
        canSave() {
            // Poți relaxa regulile, dar minim să existe o perioadă definită
            return this.extras && this.firmaId > 0;
        },
    },

    methods: {
        existBanca(extrasId) {
            const ext = this.existingExtrase.find(e => e.id === extrasId);
            return ext ? ext.banca : '';
        },
        contLabel(option) {
            return `${option.cod_complet} - ${option.descriere || ''}`
        },
        async loadConturi() {
            this.loadingConturi = true;
            try {
                // Preia toate conturile firmei
                const res = await axios.get('/api/contabilitate/plan_conturi', {
                    params: { id_firma: this.firmaId }
                });
                
                // Folosim doar conturile analitice de banca (5121%) sau lasam pe toate?
                // Utilizatorul poate selecta orice cont, dar e util sa filtram sau sa le afisam frumos
                this.listaConturi = res.data || [];
            } catch (e) {
                console.error(e);
            }
            this.loadingConturi = false;
        },
        onContSelected(cont) {
            if (!cont) {
                this.extras.banca = '';
                this.extras.iban = '';
                this.extras.moneda = 'RON';
                this.extras.sold_initial = '';
                return;
            }
            // Salvăm codul contului în "banca" pentru a păstra compatibilitatea cu backend-ul existent
            this.extras.banca = cont.cod_complet;
            this.extras.iban = cont.iban || '';
            this.extras.moneda = cont.moneda || 'RON';
            
            // Dacă avem și luna aleasă, încercăm să aducem soldul inițial
            if (this.extras.luna) {
                this.fetchSoldInitial();
            }
        },
        async fetchSoldInitial() {
            if (!this.selectedCont || !this.selectedCont.id || !this.extras.luna) return;
            
            this.loadingSold = true;
            try {
                // parse luna (ex: 2026-02)
                const [yearStr, monthStr] = this.extras.luna.split('-');
                const year = parseInt(yearStr, 10);
                const month = parseInt(monthStr, 10);
                
                const res = await axios.get(`/api/contabilitate/fisa_cont/${this.selectedCont.id}/sold_initial`, {
                    params: { year, month }
                });
                this.extras.sold_initial = res.data?.sold_initial || 0;
            } catch (e) {
                console.error(e);
                if(window.Swal) {
                    window.Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'warning',
                        title: 'Nu am putut prelua soldul inițial',
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            }
            this.loadingSold = false;
        },
        dateAzi() {
            return new Date().toISOString().slice(0, 10);
        },
        openNativePicker(refName) {
            const input = this.$refs[refName]
            if (!input) return

            // Dacă este un array de referințe (în cazul v-for), luăm primul element
            const el = Array.isArray(input) ? input[0] : input

            if (el && typeof el.showPicker === 'function') {
                el.showPicker()
            } else if (el) {
                el.focus()
                el.click()
            }
        },
        async loadExistingExtrase() {
            this.loadingList = true
            this.error = null

            try {
                const res = await axios.get('/api/administrare/work/extrase/list', {
                    params: { firma_id: this.firmaId }
                })

                const all = res.data?.extrase || []
                this.existingExtrase = all.filter(e => {
                    if (!this.fisierId) return true
                    return e.id_fisier === this.fisierId
                })
            } catch (e) {
                console.error(e)
                this.error = 'Nu s-au putut încărca extrasele existente.'
            }

            this.loadingList = false
        },

        openForm() {
            this.showForm = true
            this.error = null
            this.success = null
            this.extras.reset();
            this.selectedCont = null;
        },

        async loadTranzactii(extrasId) {
            try {
                const res = await axios.get('/api/administrare/work/extrase/detalii', {
                    params: { extras_id: extrasId },
                })
                this.tranzactiiByExtras = {
                    ...this.tranzactiiByExtras,
                    [extrasId]: res.data?.tranzactii || [],
                }
            } catch (e) {
                console.error(e)
                this.error = 'Nu s-au putut încărca liniile extrasului.'
            }
        },

        async toggleExtras(extrasId) {
            if (this.expandedExtrasId === extrasId) {
                this.expandedExtrasId = null
                return
            }

            this.expandedExtrasId = extrasId
            this.error = null
            this.success = null

            if (this.newLine && typeof this.newLine.reset === 'function') {
                this.newLine.reset()
            }
            this.liniiRJ = []

            if (!this.tranzactiiByExtras[extrasId]) {
                await this.loadTranzactii(extrasId)
            }
        },

        async addLinie(extrasId) {
            this.error = null
            this.success = null
            this.savingLine = true

            if (!this.liniiRJ.length) {
                this.error = 'Adaugă cel puțin o linie contabilă.'
                this.savingLine = false
                return
            }

            try {
                for (const linie of this.liniiRJ) {
                    // Când adăugăm linia, trebuie să calculăm contul extrasului în funcție de suma completată
                    // Dacă e Debit sum > 0, atunci cont_debit = Extras Account (pe care trebuie să-l extragem din item.banca) 
                    // și cont_credit = cont_corespondent
                    //
                    // Vom trimite pe backend contul de 'banca' al întregului extras ca cont ajutător
                    const bancaCont = this.existBanca(extrasId);
                    
                    let contDebit = null;
                    let contCredit = null;
                    let sumaDebit = linie.suma_debit || 0;
                    let sumaCredit = linie.suma_credit || 0;
                    
                    if (sumaDebit > 0) {
                        contDebit = bancaCont;
                        contCredit = linie.cont_corespondent_obj ? linie.cont_corespondent_obj.cod_complet : linie.cont_corespondent;
                    } else if (sumaCredit > 0) {
                        contCredit = bancaCont;
                        contDebit = linie.cont_corespondent_obj ? linie.cont_corespondent_obj.cod_complet : linie.cont_corespondent;
                    }

                    this.lineForm = new Form({
                        extras_id: extrasId,
                        data_tranzactie: linie.data_tranzactie || null,
                        explicatie: linie.explicatie || null,
                        suma_debit: sumaDebit,
                        suma_credit: sumaCredit,
                        tip_tranzactie: null, // Scos
                        cont_debit: contDebit,
                        cont_credit: contCredit,
                    })

                    const res = await this.lineForm.post('/api/administrare/work/extrase/adauga-linie')
                    const linieResp = res.data?.linie || res.data?.tranzactie || null

                    if (window.Swal && res.data?.status === 'success') {
                        window.Swal.fire({
                            position: 'top-end',
                            toast: true,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                            icon: 'success',
                            title: 'Succes',
                            text: res.data.message || 'Linia a fost adăugată.',
                        })
                    } else if (res.data?.message) {
                        this.success = res.data.message
                    }

                    if (linieResp) {
                        const current = this.tranzactiiByExtras[extrasId] || []
                        this.tranzactiiByExtras = {
                            ...this.tranzactiiByExtras,
                            [extrasId]: [...current, linieResp],
                        }
                    } else {
                        await this.loadTranzactii(extrasId)
                    }
                }

                // după ce am trimis toate liniile, resetăm repeaterul
                this.liniiRJ = []
            } catch (e) {
                console.error(e)
                const msg = e?.response?.data?.error || 'Nu s-au putut adăuga liniile.'
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'error',
                        title: 'Eroare',
                        text: msg,
                    })
                } else {
                    this.error = msg
                }
            }

            this.savingLine = false
        },

        startEditLine(t, extrasId) {
            this.editingLineId = t.id;
            const corespondent = (t.suma_debit > 0) ? t.cont_credit : ((t.suma_credit > 0) ? t.cont_debit : (t.cont_debit || t.cont_credit));
            let contObj = null;
            if (corespondent) {
                contObj = this.listaConturi.find(c => c.cod_complet === corespondent) || null;
            }
            this.editLineData = {
                data_tranzactie: t.data_tranzactie,
                suma_debit: Number(t.suma_debit) || 0,
                suma_credit: Number(t.suma_credit) || 0,
                explicatie: t.explicatie,
                cont_corespondent: corespondent,
                cont_corespondent_obj: contObj
            };
        },

        cancelEditLine() {
            this.editingLineId = null;
            this.editLineData = null;
        },

        async saveEditedLine(extrasId, lineId) {
            this.error = null;
            this.success = null;
            
            try {
                const bancaCont = this.existBanca(extrasId);
                let contDebit = null;
                let contCredit = null;
                let sumaDebit = this.editLineData.suma_debit || 0;
                let sumaCredit = this.editLineData.suma_credit || 0;
                let coresp = this.editLineData.cont_corespondent_obj ? this.editLineData.cont_corespondent_obj.cod_complet : this.editLineData.cont_corespondent;

                if (sumaDebit > 0) {
                    contDebit = bancaCont;
                    contCredit = coresp;
                } else if (sumaCredit > 0) {
                    contCredit = bancaCont;
                    contDebit = coresp;
                }
                
                const payload = {
                    extras_id: extrasId,
                    linii: [{
                        id: lineId,
                        data_tranzactie: this.editLineData.data_tranzactie || null,
                        explicatie: this.editLineData.explicatie || null,
                        suma_debit: sumaDebit,
                        suma_credit: sumaCredit,
                        cont_debit: contDebit,
                        cont_credit: contCredit
                    }]
                };

                const res = await axios.post('/api/administrare/work/extrase/salveaza-linii', payload);

                if (window.Swal && res.data?.status === 'success') {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                        icon: 'success',
                        title: 'Succes',
                        text: res.data.message || 'Linia a fost modificată.',
                    });
                }
                
                this.cancelEditLine();
                await this.loadTranzactii(extrasId);
            } catch (e) {
                console.error(e);
                const msg = e?.response?.data?.error || e?.response?.data?.message || 'Eroare la salvarea liniei.';
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'error',
                        title: 'Eroare',
                        text: msg,
                    });
                } else {
                    this.error = msg;
                }
            }
        },

        async saveExtrase() {
            this.error = null
            this.success = null
            this.saving = true

            // pregătim formularul v-form pentru extras
            this.formExtras = new Form({
                id_firma: this.firmaId,
                id_fisier: this.fisierId || null,
                extrase: [this.extras],
            })

            try {
                const res = await this.formExtras.post('/api/administrare/work/extrase/store')

                // toast de succes
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'success',
                        title: 'Succes',
                        text: res.data?.message || 'Extrasul a fost salvat.',
                    })
                } else {
                    this.success = res.data?.message || 'Extrasul a fost salvat.'
                }

                // Reîncarcă lista de extrase pentru acest fișier
                await this.loadExistingExtrase()
                this.showForm = false
                this.$emit('updated')
            } catch (e) {
                console.error(e)
                const msg = e?.response?.data?.error || 'A apărut o eroare la salvare.'
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'error',
                        title: 'Eroare',
                        text: msg,
                    })
                } else {
                    this.error = msg
                }
            }

            this.saving = false
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
/* =====================
   Vue-Multiselect tuning (Bootstrap-like, theme-safe)
   ===================== */
:deep(.multiselect) {
  min-height: 38px;
  padding: 0;
}

:deep(.multiselect__tags) {
  min-height: 38px;
  border-radius: 0.475rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 1px solid var(--bs-border-color, #e4e6ef) !important;
}

:deep(.multiselect__single) {
  line-height: 1.5;
  padding: 0;
  margin: 0;
  background: transparent !important;
  color: var(--bs-body-color) !important;
}

:deep(.multiselect__placeholder) {
  margin: 0;
  color: var(--bs-secondary-color, rgba(0, 0, 0, .55)) !important;
}

:deep(.multiselect__input) {
  background: transparent !important;
  color: var(--bs-body-color) !important;
  caret-color: var(--bs-primary, #3e97ff) !important;
}

:deep(.multiselect__content-wrapper) {
  z-index: 999999 !important;
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 1px solid var(--bs-border-color, #e4e6ef) !important;
}

:deep(.multiselect__option) {
  padding: 6px 8px;
}

:deep(.multiselect__option--selected) {
  background: rgba(var(--bs-primary-rgb), 0.12) !important;
  color: inherit !important;
}

:deep(.multiselect__option--highlight),
:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: var(--bs-primary, #3e97ff) !important;
  color: var(--bs-primary-inverse, #fff) !important;
}

/* Stiluri compacte pentru Multiselect utilizat în tabele (ex: Linii Contabile) */
.table-sm :deep(.multiselect) {
  min-height: 31px;
  font-size: 0.85rem;
}
.table-sm :deep(.multiselect__tags) {
  min-height: 31px;
  padding: 2px 30px 2px 6px; /* spațiu pentru text și butonul de dropdown */
  border-radius: 0.25rem;
}
.table-sm :deep(.multiselect__select) {
  height: 31px;
  top: 0;
}
.table-sm :deep(.multiselect__single),
.table-sm :deep(.multiselect__input),
.table-sm :deep(.multiselect__placeholder) {
  font-size: 0.85rem;
  line-height: normal;
}
.table-sm :deep(.multiselect__option) {
  font-size: 0.85rem;
  padding: 4px 8px;
}
.table-sm :deep(.multiselect__content-wrapper) {
  /* Nu mai acoperă atâta spațiu vizual cu marginile mari */
}
</style>